var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef } from 'react';
import { Icon, Root, Secondary, Title } from './styled';
export const InlineLink = forwardRef((props, forwardedRef) => {
    const { children, icon, prefix, suffix, as, to } = props, restProps = __rest(props, ["children", "icon", "prefix", "suffix", "as", "to"]);
    return (<Root ref={forwardedRef} {...restProps} as={as} to={to}>
      {icon && <Icon aria-hidden="true">{icon}</Icon>}
      {prefix && <Secondary>{prefix}</Secondary>}
      <Title>{children}</Title>
      {suffix && <Secondary>{suffix}</Secondary>}
    </Root>);
});
